import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GenericService } from "app/commons/generic.service";
import { environment } from "environments/environment";
import { ComplementoEstudante } from "models/complemento-estudante";
import { Estudante } from "models/estudante";
import { DetalheEstudante } from "models/estudante-detalhe";
import { Observable } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class EstudanteService extends GenericService {
    private relativePath = "v1/estudantes";

    constructor(http: HttpClient) {
        super(http);
    }

    salvarEstudante(estudante: Estudante): Observable<any> {
        return this.http.post(environment.url + this.relativePath, estudante);
    }

    atualizarDadosEstudante(estudante: DetalheEstudante): Observable<any> {
        const headers = { "Content-Type": "application/json" };

        return this.http.put(`${environment.url}${this.relativePath}/${estudante.id}`, JSON.stringify(estudante), {
            headers,
        });
    }

    findById(id: number): Observable<DetalheEstudante> {
        return this.getMethod(`${this.relativePath}/${id}`);
    }

    salvarComplementoEstudante(id: number, estudante: ComplementoEstudante): Observable<any> {
        return this.http.put(`${environment.url}${this.relativePath}/${id}/complementar`, estudante);
    }
}
